import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1fc8d39a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { getElColorPrimary } from '@/utils/theme-color'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'

import type { PortTypeDistribution } from '../port-manage.service'

/** 与端口列表接口 is_risk_port 一致：1 风险，2 未知 */
export type PortTypeSliceFilter = { is_risk_port: 1 | 2 }


export default /*#__PURE__*/_defineComponent({
  __name: 'port-type-distribution-chart',
  props: {
  /** 端口类型分布数据 */
  rawData: {
    type: Object as () => PortTypeDistribution | undefined,
    default: undefined,
  },
},
  emits: ["sliceClick"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const emit = __emit

const props = __props

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

/** 图表数据 */
const chartData = computed(() => {
  if (!props.rawData) return []
  return [
    { name: t('portManage.riskPort'), value: props.rawData.risk_port_count, color: '#E54545' }, // dm-keep
    { name: t('portManage.unknownPort'), value: props.rawData.unknown_port_count, color: getElColorPrimary() },
  ]
})

const totalCount = computed(() =>
  chartData.value.reduce((sum, item) => sum + item.value, 0)
)

const hasData = computed(() => totalCount.value > 0)

function getChartData() {
  return chartData.value.map((item, index) => ({
    value: item.value,
    name: item.name,
    /** 0: 风险端口 1: 未知端口 → 接口 1/2 */
    is_risk_port: (index === 0 ? 1 : 2) as 1 | 2,
    itemStyle: {
      color: item.color,
    },
  }))
}

function createChart() {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
}

function getChartOption() {
  const option = {
    series: [{
      name: t('portManage.portCount'),
      data: getChartData(),
    }],
  }

  return getAssignPieOption(option, { unit: t('portManage.unitPort') })
}

function bindChartClick() {
  if (!chartInstance) return
  chartInstance.off('click')
  chartInstance.on('click', (params: { data?: { is_risk_port?: 1 | 2 } }) => {
    const port = params.data?.is_risk_port
    if (port === 1 || port === 2) {
      emit('sliceClick', { is_risk_port: port })
    }
  })
}

function renderChart() {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
  bindChartClick()
}

function initChart() {
  chartInstance?.dispose()
  createChart()
  renderChart()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance?.resize()
})

watch(() => props.rawData, () => {
  if (!hasData.value) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance?.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    class: "port-type-distribution-chart-wrap",
    title: _ctx.$t('portManage.portTypeDist')
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart"
        }, null, 512),
        _createVNode(PieCenter, {
          title: _ctx.$t('portManage.totalCount'),
          value: totalCount.value,
          unit: _ctx.$t('portManage.unitPort')
        }, null, 8, ["title", "value", "unit"])
      ], 512), [
        [_vShow, hasData.value]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "100%",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !hasData.value]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})